/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".code-editor-modal-container{width:800px}code-editor-modal{display:block}code-editor-modal .modal-header{margin:0 0 15px}code-editor-modal .editor{min-height:550px;border:1px solid #e0e0e0;font-size:1.4rem}"];
export { styles as styles };
